import type { DoctorDTO } from '@/services/doctors';
import type { PatientDTO } from '@/services/patients';

/** Retorna true se o médico está ativo (user.status = active E isActive != false) */
export function isDoctorActive(doctor: DoctorDTO): boolean {
  if (doctor.user?.status === 'suspended') return false;
  if (doctor.isActive === false) return false;
  return true;
}

/** Retorna true se o paciente está ativo */
export function isPatientActive(patient: PatientDTO): boolean {
  return patient.user?.status !== 'suspended';
}
